import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { TalonPagosPage } from './talon-pagos/talon-pagos.component';
import { ConstanciaAcreditacionNoAfiliacionPage } from './constancia-acreditacion-no-afiliacion/constancia-acreditacion-no-afiliacion.component';

let moduleName = 'issste';

export const issste: Routes = [
  {
    path: `${moduleName}/talon-pagos`,
    component: TalonPagosPage,
    title: 'ISSSTE - Talón de pagos.',
    canActivate: [authGuard, hasPermissionsGuard(['issste_talon_pagos_access'])],
  },
  {
    path: `${moduleName}/constancia-acreditacion-no-afiliacion`,
    component: ConstanciaAcreditacionNoAfiliacionPage,
    title: 'ISSSTE - Constancia de acreditación de no afiliación.',
    canActivate: [authGuard, hasPermissionsGuard(['issste_constancia_acreditacion_no_afiliacion_access'])],
  },
];
